import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} aria-label="Note 5 sur 5" data-id="element-202" data-mp="3gpcmbz67awza">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} aria-hidden="true" className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-203" data-mp="3kolgv692eyvw" />)}
    </div>;
}